module.exports = __webpack_public_path__ + "static/media/Citation_Set.829af890.usdz";